import { ReactElement, createContext, useRef, useState } from 'react';
import { useLocation } from 'react-router';

const FilterContext = createContext(null);
function FilterProvider({ children }: { children: ReactElement }) {
  const [storedFilter, setFullFilter] = useState(null);

  const storedOrganizedStatus = useRef(null);
  const storedTextTypeSearch = useRef(null);

  const location = useLocation();
  const currentLocation = location.pathname.replace(/\//g, '');

  const setStoredTextTypeSearch = (textType: number) => {
    let data = { ...storedTextTypeSearch.current };
    if (!storedTextTypeSearch.current) {
      data = {};
      data[currentLocation] = textType;
      storedTextTypeSearch.current = data;
      return;
    }
    data[currentLocation] = textType;
    storedTextTypeSearch.current = data;
  };

  const setStoredFilter = (params: { [key: string]: unknown }) => {
    let data = { ...storedFilter };
    if (!storedFilter) {
      data = {};
      data[currentLocation] = params;
      setFullFilter(data);
      return;
    }
    data[currentLocation] = params;
    setFullFilter(data);
  };

  return (
    <FilterContext.Provider
      value={{
        storedFilter,
        setStoredFilter,
        currentLocation,
        storedOrganizedStatus,
        storedTextTypeSearch,
        setStoredTextTypeSearch
      }}
    >
      {children}
    </FilterContext.Provider>
  );
}

export { FilterProvider, FilterContext };
